import BaseFeature from '@appblocks/codegeneration/BaseFeature';
import {
    SettingType, CodeBlock, BlockType, ValidationMessage, ValidationMessageType,
} from '@appblocks/codegeneration/types';

export default class CustomFeatureSetting extends BaseFeature {
    constructor() {
        super();
        this.name = 'Dropdown Option';
        this.id = 'custom_feature_setting_option';
        this.singleInstance = false;
        this.settings = this.settings.concat([
            {
                id: 'LABEL',
                name: 'Label',
                settingType: SettingType.STRING,
                required: true,
                default: 'Label',
            },
            {
                id: 'VALUE',
                name: 'Value',
                settingType: SettingType.STRING,
                required: true,
                default: '0',
            },
        ]);
    }
}
